import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const translateTextFunc = createAsyncThunk(
  "translate text function",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await api.put(`dashboard/languages/${id}`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
// languages

const translateTextSlicer = createSlice({
  name: "translate text slicer",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(translateTextFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    });
    builder.addCase(translateTextFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.apiErrors = action.payload?.errors || {};
    });
    builder.addCase(translateTextFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.successMessage = action.payload?.message || "";
    });
  },
});

export default translateTextSlicer.reducer;
